export default {
    name: 'getDocumentsUrl',
    components: {},
    mixins: [],
    props: {},
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() {
    },
    methods: {
        getDocumentsUrl (document)  {
            if ('development' === process.env.NODE_ENV) {
                return `http://simulateur.lasolutionarchibald.test/assets/documents/${document}`;
            }

            return `https://simulateur.lasolutionarchibald.com/assets/documents/${document}`;
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/getDocumentsUrl.js